var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Popper } from '@material-ui/core';
import React, { useState, useContext, useEffect, useRef } from 'react';
import { EditGridSelectTags, Button, TagsButtons } from '..';
import { BPMSoundsGeneric, SoundManager } from '../..';
import { CLOSE_SVG } from '../../assets';
import { EventEmitter } from 'events';
import { EditModeContextConsumer, SoundDownloadContext } from '../../context';
import $ from 'jquery';
var SoundTagEditorEventEmitter = new EventEmitter();
SoundTagEditorEventEmitter.setMaxListeners(100);
var SoundTags = function (_a) {
    var sound = _a.sound, onTagClick = _a.onTagClick;
    var _b = useState(false), showPopup = _b[0], setShowPopup = _b[1];
    var _c = useState(false), didChange = _c[0], setDidChange = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var anchor = useRef(null);
    var _e = useState(sound.Tags || []), tags = _e[0], setTags = _e[1];
    var soundDownloadContext = useContext(SoundDownloadContext);
    var editListener = function (_a) {
        var toAdd = _a.toAdd, toRemove = _a.toRemove, from = _a.from;
        if (soundDownloadContext.includes(sound.id)) {
            if (from == sound.id) {
                return;
            }
            var newTags_1 = tags.slice();
            toAdd.forEach(function (tag) {
                newTags_1.push(tag);
            });
            var toRemoveIds_1 = toRemove.map(function (t) { return t.id; });
            newTags_1 = newTags_1.filter(function (tag) {
                return !toRemoveIds_1.includes();
            });
            setTags(newTags_1);
        }
    };
    useEffect(function () {
        SoundTagEditorEventEmitter.addListener('edited', editListener);
        return function () {
            SoundTagEditorEventEmitter.removeListener("edited", editListener);
        };
    }, [soundDownloadContext]);
    useEffect(function () {
        var _a;
        if (tags.length != ((_a = sound.Tags) === null || _a === void 0 ? void 0 : _a.length)) {
            setDidChange(true);
        }
        else {
            var soundTagIds_1 = sound.Tags.map(function (t) { return t.id; });
            setDidChange(!tags.every(function (tag) {
                return soundTagIds_1.includes(tag.id);
            }));
        }
    }, [tags, sound]);
    function getTagDelta(tags) {
        var _a;
        var toRemove = ((_a = sound.Tags) === null || _a === void 0 ? void 0 : _a.filter(function (tag) {
            return !tags.map(function (t) { return t.id; }).includes(tag.id);
        })) || [];
        var toAdd = tags.filter(function (tag) {
            var _a;
            return !((_a = sound.Tags) === null || _a === void 0 ? void 0 : _a.map(function (t) { return t.id; }).includes(tag.id));
        }) || [];
        return { toRemove: toRemove, toAdd: toAdd };
    }
    return (React.createElement(EditModeContextConsumer, null, function (editing) {
        var buttons = tags.map(function (tag) {
            return {
                buttonText: tag.name,
                border: true,
                height: '2.6rem',
                fontSize: '1.1rem',
                rightTextFontSize: '1.1rem',
                variation: 'tagTiny',
                onClick: function () {
                    if (!editing)
                        onTagClick(tag);
                },
                onImageClick: function () {
                    setTags(tags.filter(function (t) { return t.id != tag.id; }));
                },
                image: editing ? CLOSE_SVG : undefined
            };
        });
        if (editing) {
            buttons.push({
                buttonText: '+ Add Tags',
                onClick: function () {
                    setShowPopup(true);
                },
                variation: 'tagTiny',
                border: true,
            });
        }
        return (React.createElement("div", { ref: anchor, className: "button-container " + (editing ? 'editing' : ''), style: editing ? { maxHeight: 'max-content' } : {} },
            editing && React.createElement(EditGridSelectTags, { closed: !showPopup, onClosed: function (close) {
                    setShowPopup(!close);
                }, currentTags: tags, onTagsSelected: function (tags) {
                    SoundTagEditorEventEmitter.emit('edited', __assign(__assign({}, getTagDelta(tags)), { from: sound.id }));
                    setTags(tags);
                }, anchor: anchor.current }),
            editing && didChange && React.createElement(Popper, { anchorEl: anchor.current, open: true, placement: 'right', modifiers: {
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: 'window',
                    }
                }, style: { zIndex: 300 } },
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(Button, { buttonText: 'Save', className: 'BPM-Button sound-tag-button-save', loading: loading, backgroundColor: '--var(--primary)', textColor: 'white', onClick: function () {
                            setLoading(true);
                            var _a = getTagDelta(tags), toRemove = _a.toRemove, toAdd = _a.toAdd;
                            var removePromise = Promise.all(toRemove.map(function (rem) { return BPMSoundsGeneric.get().deleteSoundTag(sound.id, rem.id); }));
                            var addPromise = BPMSoundsGeneric.get().addSoundTags(sound.id, toAdd.map(function (t) { return t.id; }));
                            Promise.all([removePromise, addPromise]).finally(function () {
                                return BPMSoundsGeneric.get().getSound(sound.id).then(function (sound) {
                                    SoundManager.getInstance().updateSound(sound);
                                    setLoading(false);
                                }).catch(function (err) {
                                    setLoading(false);
                                });
                            });
                        } }),
                    showPopup && soundDownloadContext.length &&
                        React.createElement(Button, { buttonText: 'Save All', loading: loading, style: { marginRight: 8 }, backgroundColor: 'var(--primary)', textColor: 'white', onClick: function () {
                                $('.sound-tag-button-save').each(function () {
                                    $(this).trigger('click');
                                });
                            } }))),
            React.createElement(TagsButtons, { buttons: buttons })));
    }));
};
export default SoundTags;
//# sourceMappingURL=SoundTags.js.map